var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLetter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 40,
    height: 40,
    rx: 5,
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0605 25.5501C16.0605 25.0476 16.4528 24.6401 16.9367 24.6401H24.8044C25.2883 24.6401 25.6805 25.0476 25.6805 25.5501C25.6805 26.0527 25.2883 26.4601 24.8044 26.4601H16.9367C16.4528 26.4601 16.0605 26.0527 16.0605 25.5501Z",
    fill: "#6F8EF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0605 21.1302C16.0605 20.6276 16.4528 20.2202 16.9367 20.2202H24.8044C25.2883 20.2202 25.6805 20.6276 25.6805 21.1302C25.6805 21.6328 25.2883 22.0402 24.8044 22.0402H16.9367C16.4528 22.0402 16.0605 21.6328 16.0605 21.1302Z",
    fill: "#6F8EF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0605 16.45C16.0605 15.9475 16.4467 15.54 16.923 15.54H19.8781C20.3544 15.54 20.7405 15.9475 20.7405 16.45C20.7405 16.9526 20.3544 17.36 19.8781 17.36H16.923C16.4467 17.36 16.0605 16.9526 16.0605 16.45Z",
    fill: "#6F8EF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0611 10.0801L25.0616 10.0801C26.7845 10.0801 28.2616 10.6465 29.307 11.721C30.3491 12.7921 30.8804 14.2834 30.8804 15.9836V26.0166C30.8804 27.7088 30.3529 29.1934 29.3194 30.2627C28.2826 31.3354 26.8173 31.9063 25.1075 31.9168L25.1021 31.9168L16.6788 31.9201L16.6785 31.9201C16.6784 31.9201 16.6784 31.9201 16.678 31.0429L16.6785 31.9201H16.678C14.9551 31.9201 13.4783 31.3536 12.4331 30.279C11.3913 29.2079 10.8604 27.7166 10.8604 26.0166V15.9836C10.8604 14.2915 11.3874 12.8071 12.4207 11.738C13.4573 10.6655 14.9224 10.0949 16.6321 10.0845L16.6375 10.0844L25.0611 10.0801C25.0612 10.0801 25.0611 10.0801 25.0616 10.9573L25.0611 10.0801ZM25.0616 11.8345H25.0618C26.389 11.8345 27.3808 12.2625 28.0417 12.9418C28.706 13.6246 29.1186 14.6464 29.1186 15.9836V26.0166C29.1186 27.3465 28.7093 28.3641 28.0501 29.0461C27.3946 29.7244 26.412 30.1538 25.0992 30.1624C25.0983 30.1624 25.0975 30.1624 25.0967 30.1624L16.6792 30.1657L16.6781 30.1657C15.3508 30.1657 14.3592 29.7377 13.6986 29.0585C13.0345 28.3758 12.6221 27.3539 12.6221 26.0166V15.9836C12.6221 14.6535 13.0313 13.6362 13.6901 12.9546C14.3453 12.2767 15.3275 11.8474 16.6405 11.8388L25.0616 11.8345Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetter);
export default __webpack_public_path__ + "static/media/Letter.52e382e0a14aa5d7d3e084dc03abe0d5.svg";
export { ForwardRef as ReactComponent };